module.exports = __webpack_public_path__ + "media/images/c-projectGenreLabel/icon-8d90da8503786554afc05d50bc61492c.svg";